import './emptyContent.scss'
import {MSIcon, SimpleDiscordIcon, SlackIcon, TelegramIcon, WebhookIcon} from '../../icons'
import types from '../../data/channelTypes.json'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const EmptyTeamChannels = ({openModal}) => {
    const text = useNamespaceTranslations('notifications')
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const channelElement = (name, icon, type) => {
        return {name, icon, type}
    }

    const channels = [
        channelElement('Webhook', <WebhookIcon/>, types.types.webhook),
        channelElement('Slack', <SlackIcon/>, types.types.slack),
        channelElement('MS Teams', <MSIcon className="ms-icon"/>, types.types.ms_teams),
        channelElement('Discord', <SimpleDiscordIcon/>, types.types.discord),
        channelElement('Telegram', <TelegramIcon className="telegram"/>, types.types.telegram)
    ]

    return (
        <div className={classNames('empty-team-channels', {
            dark: isDarkMode
        })}>
            <div className="channel-container">
                <div className="info">
                    <h3>
                        <span className="text">{text.choose_way}</span>{' '}
                        <span className="text">{text.get_alert}</span>
                    </h3>
                    <p>{text.empty_content_desc}</p>
                </div>
                <div className="content">
                    {channels.map(item => (
                        <div className="card" key={item.type} onClick={() => openModal(item.type)}>
                            <span>{item.icon}</span>
                            <span>{item.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default EmptyTeamChannels
